export default "__VITE_ASSET__56bc2ee3__"